import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const ACTIVITYTOOL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ActivityTool.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const ACTIVITYTOOL_CONFIG = {
  entityName: 'ActivityTool',
  localizationKey: 'Controlling::Entity.ActivityTool',
  fields: ACTIVITYTOOL_FIELDS,
  permission: 'ControllingActivities.ActivityTools',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
